import moment from "moment";
import accounting from "accounting";
import { formatInputDate } from "../utils/Time";
import { findItemInArray } from "../utils/ManageArray";

const autoDisplayValue = ({ name = "", type = "", findValue = null }) => {
  if (findValue) {
    const { data, key, value } = findValue;
    const objValue = findItemInArray(data, key, value);

    if (!objValue) return "";

    const isValue = name
      .split(".")
      .reduce((obj, prop) => obj?.[prop], objValue);

    return type === "date" ? formatInputDate(isValue, "Local").date : isValue;
  }
};

const formatFileName = (filename) => filename?.slice(14) || "";

const formatDate = (date, format = "DD/MM/YYYY") =>
  date ? moment(date).format(format) : "";

const formatTime = (date, format = "HH:MM") =>
  date ? moment(date).format(format) : "";

const formatDateTime = (date, format = "DD/MM/YYYY HH:MM:SS น.") =>
  date ? moment(date).format(format) : "";

const formatDateTableForm = (date) =>
  date ? formatInputDate(date, "Local").date : "";

const formatCurrencyToNumber = (numString) =>
  Number(numString?.toString().replace(/,/g, ""));

const formatDateFromXlxs = (date) => {
  let converted_date = new Date(Math.round((date - 25569) * 864e5));
  converted_date = moment(converted_date).format('DD-MM-YY')
  return converted_date
}
const formatCurrency = (
  amount = "",
  symbol = "",
  format = "%v",
  precision = 0
) => {
  const cleanAmount = formatCurrencyToNumber(amount);

  return Number(cleanAmount) > 0
    ? accounting.formatMoney(cleanAmount, {
        symbol,
        format,
        precision,
        thousand: ","
      })
    : "";
};

const formatSplitKey = (key = "", separator = "", data = null) =>
  key.split(separator).reduce((obj, prop) => obj?.[prop], data) ?? "";

const plusStringValue = (plusString = [], operator = "", data = null) =>
  plusString.reduce(
    (sumString, str) => sumString + formatSplitKey(str, ".", data) + operator,
    ""
  ) ?? "";

export {
  autoDisplayValue,
  formatFileName,
  formatDate,
  formatDateTime,
  formatTime,
  formatDateTableForm,
  formatCurrencyToNumber,
  formatCurrency,
  formatSplitKey,
  plusStringValue,
  formatDateFromXlxs
};
